<template>
  <v-app v-if="isAuthenticated">
    <app-bar />
    <!-- Sizes your content based upon application components -->
    <v-main>
      <!-- Provides the application the proper gutter -->
      <v-container fluid>
        <!-- If using vue-router -->
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('authentication')
import config from '@/utils/config'
import AppBar from '@/components/App/AppBar.vue'

export default {
  components: { AppBar },
  name: 'App',
  data: () => ({
    environment: config.PEARL_ENVIRONMENT,
    version: config.VERSION
  }),
  computed: {
    ...mapGetters(['isAuthenticated'])
  }
}
</script>
